var map = {
	"./apple-touch-icon.png": [
		7844,
		844
	],
	"./bot-illustration-2.webp": [
		2644,
		644
	],
	"./diia_gradient_01.webp": [
		3425,
		425
	],
	"./favicon-16x16.png": [
		1227,
		227
	],
	"./favicon-32x32.png": [
		5875,
		875
	],
	"./ic_xpay.svg": [
		2472
	],
	"./logo-wb-footer.png": [
		6187,
		187
	],
	"./logo-wb.png": [
		375,
		375
	],
	"./qr-code-2.svg": [
		1485,
		485
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1628;
module.exports = webpackAsyncContext;